export default __webpack_public_path__ + "static/media/Slash.49e4899f.svg";